import { Link } from 'react-router-dom';

const ServicesDetailed = () => {
  const services = [
    {
      icon: 'ri-global-line',
      title: 'Website & Social Media Account Creation',
      description: 'Launch your digital presence with a professionally designed website and optimized social media accounts across all major platforms.',
      features: [
        'Custom Website Design',
        'Social Media Profile Setup',
        'Brand Integration',
        'Mobile Responsive Design',
      ],
      gradient: 'from-[#FF6B35]/20 to-[#FF6B35]/5',
      color: '#FF6B35',
    },
    {
      icon: 'ri-search-line',
      title: 'Website SEO Management',
      description: 'Boost your online visibility with comprehensive SEO strategies that drive organic traffic and improve search engine rankings.',
      features: [
        'Keyword Research & Optimization',
        'On-Page SEO',
        'Technical SEO Audit',
        'Monthly Performance Reports',
      ],
      gradient: 'from-[#00D9FF]/20 to-[#00D9FF]/5',
      color: '#00D9FF',
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Social Media Account Management',
      description: 'Grow your brand presence with strategic content creation, community engagement, and consistent posting across all platforms.',
      features: [
        'Content Creation & Scheduling',
        'Community Management',
        'Performance Analytics',
        'Brand Voice Development',
      ],
      gradient: 'from-[#10B981]/20 to-[#10B981]/5',
      color: '#10B981',
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Meta & Google Ads',
      description: 'Maximize your ROI with expertly managed advertising campaigns on Meta (Facebook & Instagram) and Google platforms.',
      features: [
        'Campaign Strategy & Setup',
        'Ad Creative Development',
        'Audience Targeting',
        'Performance Optimization',
      ],
      gradient: 'from-[#F59E0B]/20 to-[#F59E0B]/5',
      color: '#F59E0B',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Business Consultancy',
      description: 'Strategic business guidance to optimize operations, drive growth, and achieve your organizational goals with expert insights and actionable recommendations.',
      features: [
        'Business Strategy Development',
        'Market Analysis & Research',
        'Operational Efficiency',
        'Growth Planning & Execution',
      ],
      gradient: 'from-[#8B5CF6]/20 to-[#8B5CF6]/5',
      color: '#8B5CF6',
    },
    {
      icon: 'ri-building-line',
      title: 'B2B Marketing',
      description: 'Specialized marketing strategies designed for business-to-business relationships, focusing on lead generation, nurturing, and enterprise-level growth solutions.',
      features: [
        'Lead Generation Campaigns',
        'Account-Based Marketing',
        'LinkedIn Marketing Strategy',
        'Sales Enablement Content',
      ],
      gradient: 'from-[#EC4899]/20 to-[#EC4899]/5',
      color: '#EC4899',
    },
  ];

  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white/50 backdrop-blur-md rounded-3xl p-12 border border-gray-200 hover:border-transparent hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              style={{
                background: `linear-gradient(135deg, ${service.color}08 0%, ${service.color}02 100%)`,
              }}
            >
              {/* Icon */}
              <div className="mb-8">
                <div
                  className="w-28 h-28 rounded-2xl flex items-center justify-center transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500"
                  style={{
                    background: `linear-gradient(135deg, ${service.color} 0%, ${service.color}CC 100%)`,
                    boxShadow: `0 20px 40px ${service.color}30`,
                  }}
                >
                  <i className={`${service.icon} text-5xl text-white`}></i>
                </div>
              </div>

              {/* Content */}
              <h3 className="text-3xl font-bold text-dark mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 text-base leading-relaxed mb-6">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-3 mb-8">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i
                      className="ri-checkbox-circle-fill text-xl mt-0.5"
                      style={{ color: service.color }}
                    ></i>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Footer */}
              <div className="flex items-center justify-end pt-6 border-t border-gray-200">
                <Link
                  to="/enquiry"
                  className="inline-flex items-center gap-2 font-semibold transition-all hover:gap-4"
                  style={{ color: service.color }}
                >
                  Get Started
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Statutory Note */}
        <div className="mt-16 p-8 bg-gray-50 rounded-2xl border border-gray-200">
          <div className="flex items-start gap-4">
            <i className="ri-information-line text-2xl text-gray-600 mt-1"></i>
            <div>
              <h4 className="text-lg font-bold text-dark mb-2">Important Note</h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                For customized plans tailored to your specific business needs, please{' '}
                <Link to="/enquiry" className="text-[#FF6B35] font-semibold hover:underline">
                  contact us
                </Link>
                {' '}for a detailed consultation and pricing information.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesDetailed;
